import React, {FC} from 'react'

export const QhseAccessDenied: FC<{message?: string}> = ({
  message = 'Access denied — you do not have permission to view this QHSE screen.',
}) => (
  <div className='card'>
    <div className='card-body py-10 text-center'>
      <h4 className='fw-bold text-dark mb-3'>Access denied</h4>
      <p className='text-muted mb-0'>{message}</p>
    </div>
  </div>
)

export default QhseAccessDenied
